import type { FieldValues, Path } from "react-hook-form";
import styled from "styled-components";
import { Body } from "@songtradr-one/components-frontend";
import type { BaseProps } from "../../FormField.Parts";

// TEXT

// STYLES
export const Label = styled(Body).attrs({ forwardedAs: "label" })`
  display: flex;
  gap: 1rem;
`;

export const InnerLabel = styled(Body)`
  margin-top: -0.125rem;
  cursor: pointer;
`;

// DATA

// TYPES
export type Props<
  FormFields extends FieldValues,
  FieldName extends Path<FormFields>,
> = BaseProps<FormFields, FieldName, boolean> & {
  type: "toggle";
  size?: "small" | "large";
};

// CONSTANTS

// FUNCTIONS

// ASSETS
